import { graphql } from "../../graphql";

/**
 * Reads one row by its `(module, key)` pair. `user_id` is the third primary key column
 * but is never sent: the select permission scopes the query to the caller, so a `where`
 * lookup is used rather than `_by_pk`, which would demand a `user_id` argument the
 * transport does not have.
 */
export const ModuleStorageGet = graphql(`
  query ModuleStorageGet($module: String!, $key: String!) {
    module_storage(where: { module: { _eq: $module }, key: { _eq: $key } }, limit: 1) {
      value
      rev
    }
  }
`);

/**
 * Upserts one row and returns its new `rev`. `user_id` comes from the insert column
 * preset, and `rev` is regenerated server side by the `module_storage_touch` trigger on
 * both insert and update, which is what lets the returned value double as the SDK's
 * echo-guard write id and as the streaming cursor.
 */
export const ModuleStorageSet = graphql(`
  mutation ModuleStorageSet($module: String!, $key: String!, $value: jsonb) {
    insert_module_storage_one(
      object: { module: $module, key: $key, value: $value }
      on_conflict: { constraint: module_storage_pkey, update_columns: [value] }
    ) {
      rev
    }
  }
`);

/**
 * One cursor-based streaming subscription over all of the caller's rows. `rev` is a user-scoped bigint, so a single stream covers every module — the transport demultiplexes by `module`. The cursor is seeded with the highest `rev` the transport has seen, and a tombstoned row arrives as `value: null`.
 */
export const ModuleStorageStream = graphql(`
  subscription ModuleStorageStream($cursorRev: bigint!) {
    module_storage_stream(batch_size: 10, cursor: [{ initial_value: { rev: $cursorRev }, ordering: ASC }]) {
      module
      key
      value
      rev
    }
  }
`);
